import { formatLocalDatetime } from 'syft-acp-util/time'

import type { BlockActor, BlockLevel } from './types'

/**
 * An employer-level block hides the worker at every venue, so it keeps the
 * "Employer-level" tag when the backend unions it into a venue-filtered list.
 * That distinction is the incident blind spot the Blocks tabs exist to close.
 */
const levelLabels: Record<BlockLevel, string> = {
  employer: 'Employer-level',
  venue: 'Venue',
}

/** Returns null for an unknown level so the table renders its own empty cell. */
export const levelLabel = (level?: BlockLevel | null): string | null => (level && levelLabels[level]) || null

export const blockedByLabel = (row: {
  blocked_by?: BlockActor | null
  impersonating_user?: BlockActor | null
}): string | null => {
  const blockedBy = row.blocked_by?.name || (row.blocked_by?.id ? `User #${row.blocked_by.id}` : null)
  if (!blockedBy) {
    return null
  }

  const impersonator = row.impersonating_user?.name

  return impersonator ? `${blockedBy} (as ${impersonator})` : blockedBy
}

/**
 * Uses the same formatter as Acp.Col.Timestamp, so Expires reads identically to
 * the Blocked at column next to it.
 */
export const expiresLabel = (row: { expires_at?: string | null }): string =>
  row.expires_at ? formatLocalDatetime(row.expires_at).formatted : 'Permanent'
